import styled from 'styled-components';
import { IconButton } from '../../../IconButton';

export const Container = styled.div`
  background-color: #f5f6fa;
  padding: 2px;
  border-radius: 10px;
  width: '100%';
  font-size: 1.4rem;
  border: 1px solid #f5f6fa;
`;

export const Header = styled.div`
  background-color: #fff;
  border-radius: 10px 10px 0 0;
  display: inline-flex;
  width: 100%;
  flex-wrap: wrap
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 2px 5px;

  span{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
`;

export const Title = styled.span`
  flex: 1;
  color: #610082;
`;

export const List = styled.ul`
  border-width: 0;
  list-style-type: 'none';
`;

export const ListWithBullet = styled.ul`
  border-width: 0;
  list-style-type: 'none';
`;

export const ListItem = styled.li`
  border-width: 0;
  padding: 5px 5px;
  color: rgb(108, 108, 108);
  font-size: 0.8em;

  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;

  #option {
    margin-right: 5px;
  }

`;

export const TrashButton = styled(IconButton)`
`;
